import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';
import {
  Regions,
  riskLevels,
  RiskTypes,
  TypePerson,
  levelSEconNatu,
  levelSEconJur,
} from './ras-form.utils';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'ras-form',
  templateUrl: './ras-form.component.html',
  styleUrls: ['./ras-form.component.scss'],
})
export class RasFormComponent implements OnInit {
  /* Variable para crear la informacion adicional del caso */
  @Input() createCase: string;
  @Input() caseInfo: any;
  @Input() caseId: string;
  @Input() caseType: string;
  @Input() caseTypes: ICaseType[];
  @Output() formValid = new EventEmitter<any>();

  constructor(
    private readonly casesService: CasesService,
    private readonly fb: FormBuilder,
    public readonly userService: UserService
  ) {}

  caseIsLDC: boolean = false;
  public regions = Regions;
  public riskTypes = RiskTypes;
  public riskLevels = riskLevels;
  public typePerson = TypePerson;
  public levelSEconNatu = levelSEconNatu;
  public levelSEconJur = levelSEconJur;
  typeOfPerson = ['V', 'E', 'P', 'J', 'R', 'I', 'G'];
  form = this.fb.group({
    institucion_reportante: [
      'Banco de Venezuela S.A Banco Universal',
      [Validators.required],
    ],
    identificacion_del_reportante: ['G20009997-6', [Validators.required]], // ciRif
    fecha_del_reporte: ['', [Validators.required]],
    tipo_de_persona: ['', [Validators.required]],
    numero_de_identificacion: ['', [Validators.required]],
    // region_de_la_alerta: ['', [Validators.required]],
    nivel_de_riesgo: ['', [Validators.required]],
    tipo_de_riesgo: ['', [Validators.required]],
    deleted: [false],
    levelEcon: ['', [Validators.required]],
  });

  ngOnChanges() {
    let caseTypeName = this.getCaseTypeById(this.caseType, this.caseTypes);
    /* If true would show the ras form component */
    if (caseTypeName == 'RAS') {
      this.caseIsLDC = true;
      this.formValid.next(false);
      if (this.caseInfo) {
        if (this.form.controls.fecha_del_reporte.status == 'INVALID') {
          this.updateForm(this.caseInfo.additionalInformation);
        }
      }
      // if(this.createCase) this.createCaseAdditionalInfo()
    }
    if (caseTypeName != 'RAS') {
      this.formValid.next({
        val: true,
        additionalInformation: this.form.value,
      });
    }
  }

  updateForm(form: any) {
    this.form.controls.numero_de_identificacion.setValue(
      form.numero_de_identificacion
    );

    this.form.controls.fecha_del_reporte.setValue(form.fecha_del_reporte);
    this.form.controls.tipo_de_persona.setValue(form.tipo_de_persona);
    // this.form.controls.region_de_la_alerta.setValue(form.region_de_la_alerta);
    this.form.controls.nivel_de_riesgo.setValue(form.nivel_de_riesgo);
    this.form.controls.tipo_de_riesgo.setValue(form.tipo_de_riesgo);
    this.form.controls.potencial_de_reporte?.setValue(
      form.potencial_de_reporte
    );
    this.form.controls.levelEcon.setValue(form.levelEcon);

    this.form.controls.deleted.setValue(form.deleted);
  }

  getCaseTypeById(caseTypeId: string, caseTypes: ICaseType[]) {
    let caseType: ICaseType = caseTypes.find(
      (caseType: ICaseType) => caseType._id == caseTypeId
    );
    if (caseType) return caseType.name;
    return '';
  }

  ngOnInit() {
    this.form.statusChanges.subscribe((val) => this.onValid(val));
    this.form.controls['institucion_reportante'].disable();
    this.form.controls['identificacion_del_reportante'].disable();
  }

  onValid(val: string) {
    this.formValid.next({
      val: val == 'INVALID' ? false : true,
      additionalInformation: this.form.value,
    });
  }

  changeCi() {
    // if (this.form.value.numero_de_identificacion) {
    let ci = this.form.value.numero_de_identificacion;
    if (ci != '') {
      ci = ci.split('');
      if (!this.includesLetter(this.form.value.numero_de_identificacion)) {
        ci.splice(0, 0, this.form.value.tipo_de_persona[0].toUpperCase());
      } else {
        ci.splice(0, 1, this.form.value.tipo_de_persona[0].toUpperCase());
      }
      ci = ci.join('');
    } else {
      ci = this.form.value.tipo_de_persona[0].toUpperCase();
    }
    // ci[0] = this.form.value.tipo_de_persona[0].toLowerCase();
    this.form.controls.numero_de_identificacion.setValue(ci);
    // }
  }
  includesLetter(ci: any) {
    for (let type of this.typeOfPerson) {
      if (ci.includes(type)) {
        return ci.includes(type);
      }
    }
  }

  // createCaseAdditionalInfo(){
  //   const form: IRasAlertAdditionalInformation = this.form.value
  //   this.casesService.createCaseAdditionalInformation(this.caseId, form)
  //     .subscribe((res: any) => {})
  // }
}
